import {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useState,
} from "react";

type ScreenLayoutState =
    | "full_screen" // full screen with no drawer
    | "standard" // standard size when loading into app
    | "flex" // user set size
    | "minimized" // minimum size to show drawer
    | "maximized" // full screen with drawer
    | "none";
type LayoutContextType = {
    layoutState: ScreenLayoutState;
    setLayoutState: Dispatch<SetStateAction<ScreenLayoutState>>;
};

const LayoutContext = createContext<LayoutContextType | null>(null);

function LayoutProvider({ children }: { children: ReactNode }) {
    const [layoutState, setLayoutState] =
        useState<ScreenLayoutState>("standard");

    return (
        <LayoutContext.Provider value={{ layoutState, setLayoutState }}>
            {children}
        </LayoutContext.Provider>
    );
}

export { LayoutProvider, LayoutContext };
export type { LayoutContextType, ScreenLayoutState };
